<template>
  <div>
    <el-tabs v-model="activeUnit" :addable="true" @edit="handleEditTabs">
      <el-tab-pane v-for="(unit, key) in units" :key="key" :label="'L' + model.level + '-' + model.num + ' ' + unit.label " :name="'tab-' + key" :closable="unit.closable !== false" :lazy="true">
        <div class="unit-details">
          <div v-if="unit.intro">简介: {{unit.intro}}</div>
          <div v-if="unit.tips">说明: {{unit.tips}}</div>
          <span v-if="unit.duration">时长: {{normailUnitName(unit)}}&nbsp;</span>
          <span v-if="unit.exp">经验值: {{unit.exp}}&nbsp;</span>
          <span v-if="unit.expx">奖励系数: {{unit.expx}}</span>
          &nbsp;
          <TypeSelect class="hight-exrs" :level="model.level" v-model="exrTyoe" placeholder="高亮题型"></TypeSelect>
          <i class="el-icon-setting unit-edit hover-main" @click="updateForm(unit)"></i>
        </div>
        <component :is="unit.type + 'Form'" :ref="'unit' + key" :lid="lid" :unid="unit.id" :unit="unit" :exrtype="exrTyoe"></component>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <LessonUnitForm ref="form" :lid="lid"></LessonUnitForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LessonUnitForm from './LessonUnitForm'
import studyForm from './units/LessonUnitStudy'
import reviewForm from './units/LessonUnitReview'
import practiseForm from './units/LessonUnitPractise'
import customForm from './units/LessonUnitCustom'
import TypeSelect from './../exercise/TypeSelect'
import utils from '@/js/utils'

export default {
  name: 'LessonView',
  components: { LessonUnitForm, studyForm, reviewForm, practiseForm, customForm, TypeSelect },
  data () {
    return {
      activeUnit: 'tab-0',
      defaultUnits: [
        {
          title: '学习单元',
          type: 'study',
          closable: false
        }
      ],
      units: [],
      model: null,
      exrTyoe: null,
      dialogTitle: '',
      dialogVisible: false
    }
  },
  created () {
    this.fetchLesson()
  },
  computed: {
    lid () {
      return Number.parseInt(this.$route.params.id)
    }
  },
  methods: {
    handleEditTabs (index, action) {
      if (action === 'add') {
        this.dialogVisible = true
        setTimeout(() => {
          if (this.$refs.form.form.id) {
            this.$refs.form.reset({})
          }
        }, 1)
      } else if (action === 'remove') {
        this.$confirm('此操作将删除该单元, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var num = Number.parseInt(index.slice(4))
          if (num <= 0) {
            throw Error('索引错误')
          }
          this.$http.put(this.$urls.lesson_unit_update, { status: 0 }, {
            params: { id: this.units[num].id }
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除单元成功!',
              duration: 2000
            })
            this.units.splice(num, 1)
          }).catch((error) => {
            throw Error(error)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消单元删除',
            duration: 2000
          })
        })
      }
    },
    fetchLesson () {
      this.$http.get(this.$urls.lesson_view, {
        params: {
          id: this.lid,
          page: 1,
          'per-page': 100
        }
      }).then(res => {
        this.model = res.data
        this.units = res.data.units ? this.initUnitData(res.data.units) : []
        //this.$http.get(this.$urls.exrTypes)
      })
    },
    updateForm (unit) {
      this.dialogVisible = true
      setTimeout(() => {
        this.$refs.form.reset(unit)
      }, 1)
    },
    submitForm () {
      this.$refs.form.submit().then(res => {
        this.dialogVisible = false
        let unit = { ...this.$refs.form.form }
        let tabUnit = this.units.find(n => n.id === unit.id)
        this.initUnitItem(unit)
        if (tabUnit) {
          Object.assign(tabUnit, unit)
        } else {
          this.units.push(unit)
          this.$refs.form.reset()
        }
      })
    },
    initUnitItem (item) {
      if (item.title) {
        item.label = item.title
      } else if (item.type === 'study') {
        item.label = '学习单元'
      } else if (item.type === 'review') {
        item.label = '复习单元'
      } else if (item.type === 'practise') {
        item.label = '练习单元'
      }
      if (item.num > 0) {
        item.label = item.label + item.num
      }
      item.closable = item.num > 1
    },
    initUnitData (res) {
      let items = this.defaultUnits.filter(n => !res.some(r => r.type === n.type)).concat(res)
      items.forEach(this.initUnitItem)
      return items
    },
    normailUnitName(unit){
      return utils.asDuration(unit.duration * 1000)
    }
  }
}
</script>

<style lang="scss">
  .unit-details{
    background-color: white;
    padding: 12px;
    font-size: 14px;
    position: relative;
    min-height: 22px;
    .unit-edit{
      position: absolute;
      right: 12px;
      top:16px;
    }
  }
  .hight-exrs{
    position: fixed;
    right: 54px;
    width: 55px;
    top: 77px;
    background-color: white;
    z-index: 999;
    input{
      padding-left: 5px;
      padding-right: 22px;
    }
    .el-input__suffix{
      right:0;
    }
  }
  .entity-select-right .hight-exrs{
    right: 50vw;
    margin-right: 54px;
    @media (min-width:1600px) {
      right: 800px;
    }
  }
</style>
